import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from '../../../node_modules/rxjs/operators';

import { ActionContextMenu, ActionContextMenuEvent, ActionContextMenuEventType } from '../models/action-context-menu.model';

@Injectable({
    providedIn: 'root'
})
export class ActionContextMenuService {
    private readonly actionContextMenu: Subject<ActionContextMenuEvent>;

    constructor(
    ) {
        this.actionContextMenu = new Subject<ActionContextMenuEvent>();
    }

    public changeMenuState(actionContextMenu: ActionContextMenu): void {
        if (actionContextMenu.hidden) {
            this.updateNext(actionContextMenu, ActionContextMenuEventType.Close);
        } else {
            this.updateNext(actionContextMenu, ActionContextMenuEventType.Open);
        }
    }

    public subscribeToOpenEvents(callback: (e: ActionContextMenu) => void): Subscription {
        return this.actionContextMenu.asObservable().pipe(
            filter(event => event && event.type === ActionContextMenuEventType.Open),
            map(event => ({ itemIndex: event.itemIndex, hidden: event.hidden, actions: event.actions, groupInfo: event.groupInfo, mouseEvent: event.mouseEvent, targetElement: event.targetElement }))
        ).subscribe(callback);
    }

    public subscribeToCloseEvents(callback: (e: ActionContextMenu) => void): Subscription {
        return this.actionContextMenu.asObservable().pipe(
            filter(event => event && event.type === ActionContextMenuEventType.Close),
            map(event => ({ itemIndex: event.itemIndex, hidden: event.hidden, actions: event.actions, groupInfo: event.groupInfo, mouseEvent: event.mouseEvent, targetElement: event.targetElement }))
        ).subscribe(callback);
    }

    private updateNext(actionContextMenu: ActionContextMenu, type: ActionContextMenuEventType) {
        if (!actionContextMenu) {
            return;
        }
        this.actionContextMenu.next({
            type,
            itemIndex: actionContextMenu.itemIndex,
            hidden: actionContextMenu.hidden,
            actions: actionContextMenu.actions,
            groupInfo: actionContextMenu.groupInfo,
            mouseEvent: actionContextMenu.mouseEvent,
            targetElement: actionContextMenu.targetElement
        });
    }
}
